import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const useTransformedPathname = () => {
  const location = useLocation();
  const [transformedPathname, setTransformedPathname] = useState('');

  useEffect(() => {
    let newPathname;
    if (
      location.pathname === '/notes' ||
      location.pathname === '/a/notes' ||
      /^\/a\/notes\/\d+$/.test(location.pathname)
    ) {
      newPathname = 'Notes';
    } else {
      newPathname = 'Settings';
    }
    setTransformedPathname(newPathname);
  }, [location.pathname]);

  return transformedPathname;
};

export default useTransformedPathname;
